"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthFinishSchema = exports.OAuthStartSchema = exports.OAuthType = void 0;
const zod_1 = require("zod");
var OAuthType;
(function (OAuthType) {
    OAuthType["CONTA_AZUL"] = "conta_azul";
    OAuthType["OTHER"] = "other";
})(OAuthType = exports.OAuthType || (exports.OAuthType = {}));
const ContaAzulStartSchema = zod_1.z.object({
    type: zod_1.z.literal(OAuthType.CONTA_AZUL),
});
exports.OAuthStartSchema = zod_1.z.discriminatedUnion('type', [
    ContaAzulStartSchema,
    zod_1.z.object({ type: zod_1.z.literal(OAuthType.OTHER) }),
]);
const ContaAzulFinishSchema = zod_1.z.object({
    type: zod_1.z.literal(OAuthType.CONTA_AZUL),
    code: zod_1.z.string(),
    state: zod_1.z.string(),
});
exports.OAuthFinishSchema = zod_1.z.discriminatedUnion('type', [
    ContaAzulFinishSchema,
    zod_1.z.object({ type: zod_1.z.literal(OAuthType.OTHER) }),
]);
